import { useEffect, useState } from "react";

export function useCountdown(endIso) {
  const [left, setLeft] = useState(() => diff(endIso));
  useEffect(() => {
    const t = setInterval(() => setLeft(diff(endIso)), 1000);
    return () => clearInterval(t);
  }, [endIso]);
  return left;
}

function diff(endIso) {
  const ms = new Date(endIso).getTime() - Date.now();
  const ended = ms <= 0;
  const s = Math.max(0, Math.floor(ms / 1000));
  return {
    ended,
    d: Math.floor(s / 86400),
    h: Math.floor((s % 86400) / 3600),
    m: Math.floor((s % 3600) / 60),
    s: s % 60,
  };
}

export const pad = (n) => String(n).padStart(2, "0");
